export default "__VITE_ASSET__DiofBxnn__"